import { TExpiredIndicatorState } from './types';

export function hasExpiredIndicator(state: TExpiredIndicatorState): boolean {
  return state.hasExpiredIndicator;
}
